var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "320.000000pt",
    height: "54.000000pt",
    viewBox: "0 0 320.000000 54.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,54.000000) scale(0.100000,-0.100000)",
    fill: "#ffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2567 529 c-118 -27 -189 -124 -189 -259 0 -167 107 -269 271 -258 114 8 168 55 177 151 4 39 1 61 -14 87 -46 83 -200 113 -295 57 -46 -27 -47 -27 -47 -6 0 11 8 37 17 56 41 87 170 106 251 38 l30 -25 26 34 26 35 -37 30 c-68 56 -143 77 -216 60z m148 -314 c31 -30 31 -47 1 -82 -22 -25 -31 -28 -88 -28 -55 0 -70 4 -101 28 -20 15 -37 34 -37 42 0 8 19 25 43 39 59 36 147 37 182 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 275 l0 -255 173 0 c198 0 229 9 289 79 45 53 62 113 56 196 -10 119 -69 195 -172 222 -30 8 -109 13 -198 13 l-148 0 0 -255z m348 135 c45 -28 76 -98 69 -158 -6 -51 -29 -87 -77 -120 -31 -21 -43 -22 -139 -20 l-106 3 -3 158 -3 157 113 0 c96 0 118 -3 146 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760 276 l0 -256 210 0 210 0 0 45 0 45 -160 0 -160 0 -2 208 -3 207 -47 3 -48 3 0 -255z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393 501 c-29 -24 -33 -34 -33 -75 0 -42 2 -47 18 -41 55 23 52 34 52 -174 l0 -191 48 0 47 0 -3 255 -3 255 -47 0 c-37 -1 -54 -7 -79 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855 511 c-79 -37 -117 -111 -95 -191 29 -108 196 -153 317 -86 l43 25 -6 -27 c-23 -94 -89 -141 -180 -127 -25 3 -57 17 -75 32 l-31 26 -30 -30 -30 -30 29 -28 c45 -43 101 -65 168 -65 75 0 128 24 176 77 54 59 73 118 67 205 -7 112 -56 187 -145 225 -47 19 -160 16 -208 -6z m201 -102 c43 -26 43 -51 2 -80 -43 -31 -146 -39 -183 -15 -29 19 -35 75 -11 95 43 35 135 35 192 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3063 501 c-29 -24 -33 -34 -33 -75 0 -42 2 -47 18 -41 55 23 52 34 52 -174 l0 -191 45 0 45 0 0 255 0 255 -47 0 c-38 -1 -55 -7 -80 -29z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.35f74e728f0cf5fd4112499574681df7.svg";
export { ForwardRef as ReactComponent };